(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .component('skeletonField', {
            templateUrl: 'app/components/skeleton/field/skeleton-field.html',
            controller: skeletonFieldController,
            bindings: {
                element: '@',
                fieldClass: '@'
            },
            controllerAs: 'vm'
        });

    /** @ngInject */
    function skeletonFieldController() {
        var vm = this;
        vm.$onInit = init;

        function init() {
            vm.element = vm.element || 'input';
            vm.fieldClass = vm.fieldClass || 'form-control';
        }
    }
})();
